import React, { useEffect, useState } from 'react';
import '../../text-editor/style.scss';
import Plus from '../../../../assets/svg/Plus';
import Minus from '../../../../assets/svg/Minus';
import { IBorderValueProps } from '../../../puck/reusable-props/Border';
import {
  getBorderProps,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import { PaddingType } from '../../../puck/reusable-props/padding';
import { MarginType } from '../../../puck/reusable-props/NewMargin';
type FAQProps = {
  Title: string;
  Description: string;
  open: boolean;
  currentDeviceType: 'desktop' | 'tablet' | 'mobile';
  FAQborder: IBorderValueProps;
  FAQmargin: MarginType;
  FAQpadding: PaddingType;
  descriptionBgColor: string;
  titleBgColor: string;
  dropdownIcon?: {
    showIcon: boolean;
    iconColor: string;
    iconSize: number;
  };
};

export const FAQ: React.FC<FAQProps> = ({
  Title,
  Description,
  open,
  currentDeviceType,
  FAQmargin,
  FAQborder,
  FAQpadding,
  descriptionBgColor,
  titleBgColor,
  dropdownIcon,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(open);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="border-b border-gray-200"
      style={{
        ...getNewMarginStyles(FAQmargin, currentDeviceType),
        ...getPaddingStyles(FAQpadding, currentDeviceType),
      }}>
      <div
        className="py-4 cursor-pointer flex justify-between items-center text-editor-content"
        onClick={toggleOpen}
        aria-expanded={isOpen}
        role="button"
        style={{
          backgroundColor: titleBgColor,
          ...getBorderProps(FAQborder, currentDeviceType),
        }}>
        <div dangerouslySetInnerHTML={{ __html: Title }} />

        {dropdownIcon?.showIcon && (
          <div className="flex-shrink-0 ml-2">
            {!isOpen ? (
              <Plus
                width={dropdownIcon?.iconSize}
                height={dropdownIcon?.iconSize}
                fill={`${dropdownIcon?.iconColor}`}
              />
            ) : (
              <Minus
                width={dropdownIcon?.iconSize}
                height={dropdownIcon?.iconSize}
                fill={`${dropdownIcon?.iconColor}`}
              />
            )}
          </div>
        )}
      </div>

      {/* Simple conditional rendering instead of complex transitions */}
      {isOpen && (
        <div className="pb-4 text-editor-content">
          <div
            dangerouslySetInnerHTML={{ __html: Description }}
            style={{ backgroundColor: descriptionBgColor }}
          />
        </div>
      )}
    </div>
  );
};
